module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main